import { Link } from "react-router-dom";
import { useTheme } from "./theme-provider";
import { Sun, Moon, Menu, X } from "lucide-react";
import { useState, useEffect } from "react";

const Navbar = () => {
  const { theme, setTheme } = useTheme();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    setTheme("dark");
  }, []);

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center space-x-2">
          <img
            src={require("../assets/csc_logo.png")}
            alt="Camera Service Center"
            className="h-16 w-16"
          />
          {/* <span className="font-bold text-xl">Camera Service Center</span> */}
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-6">
          <Link
            onClick={() => window.scrollTo(0, 0)}
            to="/"
            className="text-sm font-medium transition-colors hover:text-primary"
          >
            Home
          </Link>
          <Link
            onClick={() => window.scrollTo(0, 0)}
            to="/about"
            className="text-sm font-medium transition-colors hover:text-primary"
          >
            About
          </Link>
          <Link
            onClick={() => window.scrollTo(0, 0)}
            to="/services"
            className="text-sm font-medium transition-colors hover:text-primary"
          >
            Services
          </Link>
          <Link
            onClick={() => window.scrollTo(0, 0)}
            to="/products"
            className="text-sm font-medium transition-colors hover:text-primary"
          >
            Adjustment Tools
          </Link>
          <Link
            onClick={() => window.scrollTo(0, 0)}
            to="/testimonials"
            className="text-sm font-medium transition-colors hover:text-primary"
          >
            Testimonials
          </Link>
          <Link
            onClick={() => window.scrollTo(0, 0)}
            to="/contact"
            className="text-sm font-medium transition-colors hover:text-primary"
          >
            Contact
          </Link>
        </div>

        <div className="flex items-center space-x-4">
          <button
            onClick={toggleTheme}
            className="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground h-9 w-9"
          >
            {theme === "light" ? (
              <Moon className="h-5 w-5" />
            ) : (
              <Sun className="h-5 w-5" />
            )}
            <span className="sr-only">Toggle theme</span>
          </button>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground h-9 w-9"
          >
            {isMenuOpen ? (
              <X className="h-5 w-5" />
            ) : (
              <Menu className="h-5 w-5" />
            )}
            <span className="sr-only">Toggle menu</span>
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 bg-background border-b">
            <Link
              to="/"
              className="block px-3 py-2 text-sm font-medium transition-colors hover:text-primary"
              onClick={toggleMenu}
            >
              Home
            </Link>
            <Link
              to="/about"
              className="block px-3 py-2 text-sm font-medium transition-colors hover:text-primary"
              onClick={toggleMenu}
            >
              About
            </Link>
            <Link
              to="/services"
              className="block px-3 py-2 text-sm font-medium transition-colors hover:text-primary"
              onClick={toggleMenu}
            >
              Services
            </Link>
            <Link
              to="/products"
              className="block px-3 py-2 text-sm font-medium transition-colors hover:text-primary"
              onClick={toggleMenu}
            >
              Adjustment Tools
            </Link>
            <Link
              to="/testimonials"
              className="block px-3 py-2 text-sm font-medium transition-colors hover:text-primary"
              onClick={toggleMenu}
            >
              Testimonials
            </Link>
            <Link
              to="/contact"
              className="block px-3 py-2 text-sm font-medium transition-colors hover:text-primary"
              onClick={toggleMenu}
            >
              Contact
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
